<script lang="ts">
    import { getClient } from "../utils.js";
    import type { ApprovalTaskId, TransactionId, WorkflowId } from "@repo/backend/types";
    import { logs } from "@repo/core/universal";
    import type { Attachment } from "svelte/attachments";


    const {
        data,
        onResultLoad,
    }: {
        data:
            | {
                  threadId?: string | null;
                  processingId?: number;
                  workflowId?: WorkflowId;
                  transactionId?: TransactionId;
                  approvalTaskId?: ApprovalTaskId | null;
                  token?: string | null;
                  diffMode?: boolean;
              }
            | undefined;
        onResultLoad?: (result: { relevantMessageIds: string[]; relevantAttachmentIds: string[] }) => void;
    } = $props();

    let iframe = $state<{ w: Window | null }>({ w: null });
    const transactionId = $derived(data?.transactionId);

    const iframeAttachment: Attachment<HTMLIFrameElement> = el => {
        async function fn(e: MessageEvent<{ type: string }>) {
            switch (e.data.type) {
                case "ready":
                    iframe = { w: el.contentWindow };
                    break;
                default:
                    logs.error(new Error("Unsupported iframe message"))`${e.data}`;
            }
        }
        window.addEventListener("message", fn);
        return () => {
            window.removeEventListener("message", fn);
        };
    };

    $effect(() => {
        if (iframe.w && data) {
            iframe.w.postMessage({ type: "thread_id", payload: data }, "*");
        }
    });

    $effect(() => {
        if (transactionId && onResultLoad) {
            const client = getClient({ timeoutMs: 10_000 });
            client["Get relevant transaction email parts"]({
                params: {
                    transactionId,
                },
            }).then(({ attachmentIds, messageIds }) => {
                onResultLoad({
                    relevantAttachmentIds: attachmentIds,
                    relevantMessageIds: messageIds,
                });
            });
        }
    });
</script>

<iframe
    {@attach iframeAttachment}
    title=""
    width="100%"
    height="100%"
    style="border: none;"
    src="/browser-extension"
></iframe>
